/*
  Adds the promise polyfill for IE 11
*/
require('es6-promise').polyfill();

/*
    Imports Vue and Vuex
*/
import {createStore} from 'vuex'

/*
    Initializes Vuex on Vue.
*/
import {user} from './modules/users'
import {client} from './modules/clients'

/*
  Exports our data store.
*/
export default createStore({
    modules: {
        user,
        client
    }
});
